/**
* In this file we handel to show the MedicalIssueModal details popup screen
**/
import { Modal,Button } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import ApiService from './../../services/ApiService';
import { convertUTCtoLocal,convertUTCtoDate } from './../../services/UtilsService';
import Pagination from './../../shared/components/Pagination';
import { postAnalytics } from './../../services/ReusabilityService';
import VitalsModal from './../../shared/modals/VitalsModal';
import DiagnosisAddModal from './../../shared/modals/DiagnosisAddModal';
import DiagnosisViewModal from './../../shared/modals/DiagnosisViewModal';
import PrescriptionViewModal from './PrescriptionViewModal'; 
import { useTranslation } from 'react-i18next';

function MedicalIssueModal(props) {
	//Intial state declaration
	const [data,setData]=useState([]);	
	const [count,setCount]=useState(0);	
	const [modal,setModal]=useState({});
	const [request,setRequest]=useState({page:0,limit:10,id:props.data.member});	
	const [isLoading, setIsLoading] = useState(true);
	const role = Number(localStorage.getItem('role'));
	const { t } = useTranslation();
	const [prescriptionModal, setPrescriptionModal] = useState({ showPrescription: false, prescription_items: [], name: '', main_problem: '' }); 

//Component initialize function	
	useEffect(()=>{
		const fetchData = async () => {
			setIsLoading(true); 
			try {
				var response = await ApiService.listMemberMedicalIssues(request);
				if(response.status===200){
				   setData(response.data.items);	
				   setCount(response.data.count);
				   sessionStorage.setItem('screenStartTime', new Date());
				}
			} catch (error) {
				console.error('Error fetching member medical issues:', error);
			} finally {
				setIsLoading(false); 
			}
		};
		fetchData();	
			
		//To post the Analytics data
		return async()=>{
			var reqData={};
			reqData.parent = props.data.parent;
			reqData.member = props.data.member;
			reqData.module = 'medicalIssue';
			postAnalytics(reqData);
		}
	},[request,props]);	
	
	/** 
	* To handle pagination event
	* @date we get the user selected page number
	**/
	  const handlePaginate=(data)=>{  
		  setRequest(req=>({...req,page:data}));
	  };
	  
	  //To close modal
	  const handleClose=()=>setModal({});

	// To handle View Prescription click
	const ViewPrescription = (item) => {
		setPrescriptionModal({
			showPrescription: true,
			prescription_items: item.prescription_items || [],
			main_problem: item.main_problem,
			name: props.data?.name,
			dob: props.data?.dob
		});
	};

	// To close prescription modal
	const handlePrescriptionClose = () => {
		setPrescriptionModal({ showPrescription: false, prescription_items: [], name: '', main_problem: '' });
	};
	
  return (
 <>
	
	{/* Prescription View Modal */}
	{Object.keys(prescriptionModal).length !==0 && prescriptionModal.showPrescription &&
		<PrescriptionViewModal 
			data={prescriptionModal} 
			handleClose={handlePrescriptionClose} 
		/>
	}
	{/*Import VitalsModal*/}
	{Object.keys(modal).length !==0 && modal.showVitals && <VitalsModal data={modal} handleClose={handleClose} />}
	
	{/*Import DiagnosisAddModal*/}
	{Object.keys(modal).length !==0 && modal.addDiagnosis && <DiagnosisAddModal data={modal} handleClose={handleClose} />}
	
	{/*Import DiagnosisViewModal*/}
	{Object.keys(modal).length !==0 && modal.viewDiagnosis && <DiagnosisViewModal data={modal} handleClose={handleClose} />}

  <Modal 
	show={props.data.medication} 
	onHide={props.handleClose}  
	backdrop="static"
    keyboard={false}
	size="xl"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
      <Modal.Header closeButton className={`${role===4?'admin-modal-header':''}`}>
<Modal.Title><h5 className="modal-title" id="appointmentsModalLabel"><span className="member-name text-capitalize">{props.data.name}{t('common.possessive_suffix')} {t('sidebar.medicalIssues')}</span></h5></Modal.Title>
      </Modal.Header>
      <Modal.Body>
	  	<div className="row">
			   
					<div className="col-xxl-12 mb-5 text-capitalize">
						<div className={`table-responsive ${role === 4 ? 'admin-table-responsive' : ''}`}>	
						{/*MedicalIssue Table*/}
							<table className="table table-borderless theme-table">
								<thead>
								  <tr>
									  <th>{t('table.mainProblem')}</th>
									  <th>{t('table.associatedProblem')}</th>
									  <th>{t('table.issueDate')}</th>
									  <th className="text-center">{t('table.vitals')}</th>
									  <th className="text-center">{t('modal.addDiagnosis')}</th>
									  <th className="text-center">{t('modal.viewDiagnosis')}</th>
									  <th>{t('modal.ViewPrescription')}</th>
								  </tr>
								</thead>
								<tbody>
								{data && data.length !==0 && data.map((item,i)=>(<tr key={i}>
									<td>{item.main_problem}</td>
									<td>{item.associated_problem +' - '+ convertUTCtoDate(item.createdAt)}<br/>
									  {item.update_associated_problem.map((data,index) => (
										  <div key={index}>
											{data.associated_problem} - {convertUTCtoDate(data.updatedDate)}
										  </div>
									  ))}</td>
									<td>{convertUTCtoLocal(item.createdAt)}</td>
									<td className="text-center"><span
									  onClick={()=>setModal({showVitals:true,vitalsValue:item.vitals,member:item.member,parent:item.parent})} className={`table-link ${role === 4 ? 'admin-table-link text-tmAquaDgreen' : 'text-tmBlue'}`}
									>
									  <i className="fa-solid fa-heart-pulse" toggle="tooltip" placement="top" title= {t('common.viewVitals')}></i>
									</span></td>
									<td className="text-center"><span
									  onClick={()=>setModal({addDiagnosis:true,member:item.member,parent:item.parent,report_id:item.id,dob:props.data?.dob})} className={`table-link ${role === 4 ? 'admin-table-link text-tmAquaDgreen' : 'text-tmBlue'}`}
									>
									  <i className="fa-solid fa-file-medical" toggle="tooltip" placement="top" title= {t('modal.addDiagnosis')}/>
									</span></td>
									<td className="text-center">
									<span
									  onClick={()=>setModal({viewDiagnosis:true,id:item.id,name:props.data.name, dob:props.data.dob})} className={`table-link ${role === 4 ? 'admin-table-link text-tmAquaDgreen' : 'text-tmBlue'}`}
									>
									  <i className="fa-solid fa-file-lines" toggle="tooltip" placement="top" title= {t('modal.viewDiagnosis')}/>
									</span></td>
									<td className="text-center">
											<span onClick={() => ViewPrescription(item)} style={{ cursor: 'pointer' }}>
											<i className={`fa-solid fa-file-lines ${role === 4 ? 'admin-table-link text-tmAquaDgreen' : 'text-tmBlue'}`} />
										</span>
									</td>
								</tr>))}
								{data.length ===0 && !isLoading && <tr>
									<td colSpan="8" className="text-center text-capitalize">{t('common.noRecord')}</td>
									</tr> }
								</tbody>
							</table>
							{/*End MedicalIssue Table */}
						</div>
						{/*Pagination*/}
						<div className="col-xxl-12 d-flex justify-content-center">
				{data.length !==0 && <Pagination page={request.page} handlePaginate={handlePaginate} total={count}  />}
			    </div>
				{/*End Pagination*/}
					</div>	
				</div>

	</Modal.Body>
	{/*Footer*/}
	  <Modal.Footer>
	   <Button variant="secondary" className={`btn btn-sm ${role === 4 ? 'btn-tmAquaGreen' : 'btn-tmBlue'}`} onClick={props.handleClose}>
	      {t('modal.close')}
        </Button>
	  </Modal.Footer>
	</Modal>
	</>
  );
}

export default MedicalIssueModal;
